<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler">
            <el-form-item 
                label="核准文号" 
                :class="{'table-full-row': form.spxmbh==form.by5}"
                v-if="form.by5">
                {{form.by5}}
            </el-form-item>
            <el-form-item 
                label="统一项目代码" 
                :class="{'table-full-row': !form.by5&&form.spxmbh}"
                v-if="form.spxmbh!=form.by5">
                {{form.spxmbh}}
            </el-form-item>
            <el-form-item label="项目名称">
                {{form.proname}}
            </el-form-item>
            <el-form-item label="项目类别">
                {{form.xmlbname}}
                <span v-for="(item,index) in record" style="display:block">
                    {{index+1}}、{{item}}
                </span>
            </el-form-item>
            <el-form-item label="项目法人">
                {{form.faren}}
            </el-form-item>
            <el-form-item label="项目所属地区">
                {{form.procitydisname}}
            </el-form-item>
            <el-form-item label="资金来源">
                {{form.zjlyname}}
            </el-form-item>
            <el-form-item label="资金来源详细内容">
                {{form.zjly}}
            </el-form-item>
            <el-form-item label="项目行业">
                {{form.prohyflname}}
            </el-form-item>
            <template v-if="form.xmlx==='1'">
                <el-form-item label="资金到位情况">
                    {{form.zjdwqk}}
                </el-form-item>
                <el-form-item label="技术等级">
                    {{form.jsdj}}
                </el-form-item>
            </template>
            <el-form-item label="项目规模">
                {{form.xmgm}}
            </el-form-item>
            <el-form-item label="建设内容">
                {{form.e_jsnr}}
            </el-form-item>
            <el-form-item label="监管部门">
                {{form.ext_deptname}}
            </el-form-item>
            <el-form-item label="项目级别">
                {{form.ext_prolevelname}}
            </el-form-item>
            <el-form-item label="招标估算额(万元)">
                {{form.e_zbgse}}
            </el-form-item>
            <el-form-item label="项目地址">
                {{form.proaddress}}
            </el-form-item>
            <el-form-item label="项目负责人">
                {{form.e_xmfzr}}
            </el-form-item>
            <el-form-item label="负责人手机">
                {{form.e_fzrphone}}
            </el-form-item>


            <template slot="btn" slot-scope="scope">
                <el-button v-if="isRevision!=1" icon="el-icon-circle-close" @click="scope.cancleHandler">关闭</el-button>
                <span v-if="isRevision==1"></span>
            </template>
        </my-form>

       
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'


export default {
    mixins: [ FORM_PAGE_MIXIN],

    data: () => ({
        form: {},
        record:[],
        isRevision:'',
    }),
    methods: {
     
        
    },
    created() {
        var that = this
        that.jspInit(`${that.getGetters('mngUrl')}/Zbdl/Project/detail.json`,{
            id:that.getQuery('id'),
        }, data => {
            that.form = data.model
            if(that.form.record_type){
                var arr = that.form.record_type.split(";")
                for(var i=0;i< arr.length;i++){
                    if(arr[i]==='0'){
                        that.record.push('其他')
                    }
                    for(var j=0;j< data.recordtype.length;j++){
                        if(arr[i]== data.recordtype[j].diccode){
                            that.record.push(data.recordtype[j].dicname)
                        }
                    }
                }
            }
        });
        
    },
    mounted() {
        this.isRevision = getSession('isRevision')
    },
}
</script>

<style scoped lang="scss">

</style>
